<template lang="pug">
  .product
    .product__banner
      h1.product__banner_center-text.white--text Produtos
    .product__content.max-content
      v-row.mt-12(v-for="(prod, index) in products" :key="index" align="center" justify="center")
        v-col.text-center(cols="12" md="6" :order="(index % 2 == 0) || $vuetify.breakpoint.smAndDown ? 'first' : 'last'")
          img.image(:src="prod.icon" :class="{'large': (index % 2 != 0)}")
        v-col.text-center(cols="12" md="6")
          .column.primary--text
            h3.text-center.product__content_title {{ prod.title }}
            p.text-center.mt-4.product__content_description {{ prod.description }}

    .product__banner-2
      .product__banner-2_text.white--text.text-center
        h3 Fale com um consultor
          br
          | e conheça todas as
          br
          | vantagens.
        v-btn.text-capitalize.font-weight-black.primary(rounded dark :to="{ name: 'Contact' }") Clique Aqui!

</template>

<script>

export default {
  name: 'services-contact-page',
  components: { },
  data: () => ({
    products: [
      {
        icon: require('@/assets/img/svg/home-totem.svg'),
        title: 'Totem de Autoatendimento',
        description: `O ISPTotem é um produto desenvolvido para o autoatendimento para clientes ISP's que querem ter uma maior agilidade e comodidade em seus recebimentos e outros.
          Com o ISPTotem você consegue pagar faturas e emitir segunda-vias sem que precise de um atendente, sendo assim, conseguimos trazer facilidade aos processos do seu ISP.`,
      },
      {
        icon: require('@/assets/img/svg/logo-header-min.svg'),
        title: 'Automação para recebimentos',
        description: `Automatizamos o processo de recebimento e atendimento ao cliente para seu ISP.
          Apenas com o documento CPF/CNPJ, o seu cliente consegue consultar seus débitos, fazer pagamentos do mesmo de forma integrada ao seu sistema de gestão sem a intervenção de um atendente.`,
      },
      {
        icon: require('@/assets/img/svg/totem-grey.svg'),
        title: 'Totem Personalizado',
        description: `Os equipamentos pode ser personalizados de acordo com a necessidade do cliente, tanto o tamanho da tela, quanto a parte
          estética do produto, nas cores desejadas pelo cliente ou até mesmo plotado com arte do cliente.
          Também pode ser Personalizado a tela de fundo do sistema, e a logo gerada no recibo/segunda via.`,
      },
      {
        icon: require('@/assets/img/svg/pc-graphic.svg'),
        title: 'Relatórios',
        description: `O sistema conta com relatório web, onde apresenta os documentos que por algum motivo o totem não conseguiu efetuar a baixa no sistema integrado ou até mesmo para você saber se seu totem está online.`,
      },
    ]
  }),
}
</script>

<style lang="sass" scoped>
@import "@/assets/style/mobileFirst.sass"
@import "@/assets/style/variables.sass"

.product
  background: $white
  &__banner
    min-height: 200px
    background-position: bottom
    background-image: url('../assets/img/bg-product-1.jpg')
    background-size: cover
    position: relative
    +media-min-md
      min-height: 40vh
    +media-min-lg
    &_center-text
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)

  &__banner-2
    background-image: url('../assets/img/bg-product-2.jpg')
    background-size: cover
    min-height: 570px
    position: relative
    overflow: hidden
    background-position: right
    +media-min-md
      background-position: center
      background-size: cover
      min-height: 100vh
    &_text
      position: absolute
      line-height: 25px
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      width: 100%
      +media-min-md
        left: 12%
        top: 35%
        width: auto
        transform: translate(0, -50%)
        left: 12%
        line-height: 35px
      h3
        font-size: 25px
        +media-min-md
          font-size: 35px
      .v-btn
        margin-top: 15px
        letter-spacing: normal
        font-size: 1.1rem
        +media-min-md
          font-size: 2rem
      
  &__content
    padding: 50px 20px
    .image
      width: 30%
      &.large
        width: 40%
    &_description
      +media-min-md
        padding: 0 60px
        font-size: 20px
    &_title
      font-size: 22px
      +media-min-md
        font-size: 24px
</style>